import React from 'react';
import { Global } from '@emotion/react'

export const GlobalStyles = (props) => (
    <Global
        styles={(theme) => ({
            body: {
                margin: 0,
                height: '100%',
                fontFamily: '"PT Sans", sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif',
            },
            '#app': {height: '100vh'},
            'body, #root': {height: '100vh'},
            '#custom-root, #root': {height: '100%', padding: 0},
            '.sb-show-main.sb-main-padded': {padding: 0},
            'input:focus': {
                backgroundColor: 'transparent',
            },
            '.wrapper-class': {
                // padding: '1rem',
                height: 'auto',
                border: `1px solid ${theme.colors.greys[0]}`,
            },
            '.editor-class': {
                marginTop: '-10px',
                padding: '1rem',
                height: 'auto',
                minHeight: '200px',
                border: '1px solid #ccc',
                borderTop: "transparent"
            },
            '.ReactModal__Overlay': {
              zIndex: "9999"
            },
            '.toolbar-class': {
                border: '1px solid #ccc',
            },
            '.wysiwyg-wrapper': {
                height: '100%',
                minHeight: '294px',
                borderRadius: '4px',
                border: `1px solid ${theme.colors.greys[1]}`,
            },
            '.errorBackground': {
                background: theme.colors.errorBackground,
            },
            '.errorBorder' : {
                borderWidth: '0.5px',
                borderColor: theme.colors.errorBorder
            },
            '.disabledBackground' : {
                background: theme.colors.disabledBackground,
            },
            '.disabledBorder': {
                background: theme.colors.disabledBackground,
            },
            '.disabled': {
                pointerEvents: 'none'
            }
            // '.wysiwyg-wrapper-disabled': {
            //     height: '100%',
            //     minHeight: '294px',
            //     borderRadius: '4px',
            //     pointerEvents: 'none',
            //     background: theme.colors.disabledBackground,
            //     borderColor: theme.colors.disabledOutline
            // },
            // '.wysiwyg-wrapper-error': {
            //     height: '100%',
            //     minHeight: '294px',
            //     borderRadius: '4px',
            //     borderWidth: '1px',
            //     borderStyle: 'solid',
            //     background: theme.colors.errorBackground,
            //     borderColor: theme.colors.errorOutline,
            //     // minHeight: '294px',
            //     // borderRadius: '4px',
            //     ".wysiwyg-toolbar": {
            //         background: theme.colors.errorBackground,
            //         borderColor: theme.colors.errorOutline
            //     }

            // },
            // '.wysiwyg-toolbar': {
            //     borderTop: 'none',
            //     borderLeft: 'none',
            //     borderRight: 'none',
            //     borderColor: theme.colors.greys[1]
            // },
            // '.wysiwyg-toolbar ~': {
            //     borderColor: theme.colors.greys[1],
            // },
            // '.public-DraftStyleDefault-block': {
            //     margin: 0
            // }
        })}
    />
)